import { CSSObject, Theme } from '@core-ui/react-stitch';
import getOptionBeforeStyles from '../getOptionBeforeStyles';
import getTextStyles from '../getTextStyles';

export const getFullHexColor = (hex: string, transparency?: string) => {
  const fullHexColor = hex.length < 5 ? hex + hex.substring(1) : hex;
  return transparency ? fullHexColor + transparency : fullHexColor;
};

const getOptionStyles = (
  isBR: boolean, 
  isBRRedesignEnabled: boolean
) => (base: CSSObject, { theme, selected }: { theme: Theme; selected?: boolean }): CSSObject => ({
  ...base,
  ...getTextStyles(theme, isBR, isBRRedesignEnabled),
  paddingLeft: '2.75rem',
  position: 'relative',
  '&::before': selected ? getOptionBeforeStyles(theme) : {},
  ...isBRRedesignEnabled
    ? 
    {
      backgroundColor: theme.color.inverse.b1,
      color: theme.color.b2,
      textTransform: 'capitalize',
      padding: '.5rem',
      textAlign: 'right',
      '&:hover': {
        backgroundColor: getFullHexColor(theme.color.b1, '0F'),
      },
      '&[aria-selected="true"]': {
        backgroundColor: getFullHexColor(theme.color.b1, '1A'),
      }
    }
    : {}
});

export default getOptionStyles;
